import defaultGameMenuConfig from '../../data/gameMenuDefaults.json';
import cemeteryBackground from '../../../../assets/fondocementerio.webp';
import NohoCredit from './NohoCredit';

export function GameMenuCard({
  config = defaultGameMenuConfig,
  toleranceLevel,
  speedMultiplier,
  onToleranceChange,
  onSpeedChange,
  onStart,
  isReady = true,
  startupError = '',
  preview = false,
}) {
  const { presentation, controls } = config;

  return (
    <div className={`relative my-auto w-full max-w-sm shrink-0 overflow-hidden border border-[#7EC54A]/60 bg-black/95 text-center shadow-[10px_12px_0_rgba(0,0,0,.55)] ${preview ? 'p-5' : 'p-6 md:p-8'}`}>
        <h1 className={`font-display uppercase leading-none text-[#F7E04B] drop-shadow-[3px_3px_0_#1A4D2E] ${preview ? 'text-2xl lg:text-3xl' : 'text-2xl md:text-3xl'}`}>{presentation.title}</h1>
        <p className="mx-auto mt-5 max-w-md border-l-2 border-[#7EC54A] pl-4 text-left text-sm leading-6 text-[#C5E6A0]">
          {presentation.description}
        </p>

        <div className="mt-4 border-y border-[#7EC54A]/25 py-3 text-left text-xs leading-5 text-[#C5E6A0]">
          <p><strong className="text-[#F7E04B]">Escucha. Toca. Mantén el pulso.</strong></p>
          <p>Toca cada lado cuando la nota llegue al cuadro. Si tiene cola, mantén pulsado hasta el final.</p>
          <p className="mt-1 text-[10px]">Teclado: ← / → o A / L · Pausa: Esc</p>
        </div>

        {controls.showTuning && <div className="mt-7 grid grid-cols-1 gap-4 text-left">
          <div className="border border-[#F7E04B]/30 bg-black/25 p-4">
            <label className="mb-2 block text-[9px] font-black uppercase tracking-[.16em] text-[#C9A8FF]" htmlFor={preview ? 'preview-tolerance' : 'game-tolerance'}>{controls.tolerance.label}</label>
            <div className="mb-2 flex justify-between text-[10px] font-black uppercase tracking-wider text-white" aria-hidden="true">
              <span>{controls.tolerance.lowLabel}</span><span>{controls.tolerance.middleLabel}</span><span>{controls.tolerance.highLabel}</span>
            </div>
            <input id={preview ? 'preview-tolerance' : 'game-tolerance'} type="range" min={controls.tolerance.min} max={controls.tolerance.max} step={controls.tolerance.step} value={toleranceLevel} onChange={(event) => onToleranceChange(Number(event.target.value))} className="h-2 w-full cursor-pointer appearance-none rounded-lg bg-gray-700 accent-[#7EC54A]" />
            <output className="mt-2 block text-right font-mono text-[10px] text-[#C9A8FF]">{Number(toleranceLevel).toFixed(1)}</output>
          </div>
          <div className="border border-[#F7E04B]/30 bg-black/25 p-4">
            <label className="mb-2 block text-[9px] font-black uppercase tracking-[.16em] text-[#C9A8FF]" htmlFor={preview ? 'preview-speed' : 'game-speed'}>{controls.speed.label}</label>
            <div className="mb-2 flex justify-between text-[10px] font-black uppercase tracking-wider text-white" aria-hidden="true">
              <span>{controls.speed.lowLabel}</span><span>{controls.speed.middleLabel}</span><span>{controls.speed.highLabel}</span>
            </div>
            <input id={preview ? 'preview-speed' : 'game-speed'} type="range" min={controls.speed.min} max={controls.speed.max} step={controls.speed.step} value={speedMultiplier} onChange={(event) => onSpeedChange(Number(event.target.value))} className="h-2 w-full cursor-pointer appearance-none rounded-lg bg-gray-700 accent-[#F7E04B]" />
            <output className="mt-2 block text-right font-mono text-[10px] text-[#C9A8FF]">{Number(speedMultiplier).toFixed(1)}×</output>
          </div>
        </div>}

        {startupError && <p className="mt-5 border border-red-300/40 bg-red-950/50 p-3 text-left text-xs font-bold text-red-100" role="alert">{startupError}</p>}

        <button
          type="button"
          onClick={() => onStart()}
          disabled={!isReady}
          className="mt-7 w-full border border-[#C9A8FF] bg-[#7C3AED] px-6 py-4 font-black uppercase tracking-[.14em] text-white shadow-[4px_4px_0_#0A1A0F] transition-transform hover:bg-[#6D2EB5] active:translate-x-0.5 active:translate-y-0.5 disabled:cursor-wait disabled:opacity-50 disabled:shadow-none"
        >
          {isReady ? startupError ? 'Volver a intentar' : presentation.startButtonLabel : 'Preparando el ritual…'}
        </button>
      </div>
  );
}

export default function MenuOverlay({
  visible,
  ...cardProps
}) {
  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-black bg-cover bg-center px-4 pt-[max(1rem,env(safe-area-inset-top))] pointer-events-auto"
      style={{ backgroundImage: `url(${cemeteryBackground})`, backgroundColor: '#000', overscrollBehavior: 'none' }}
    >
      <GameMenuCard {...cardProps} />
      <div className="pointer-events-none absolute inset-x-0 bottom-0 flex justify-center px-4 pb-[max(.6rem,env(safe-area-inset-bottom))]">
        <NohoCredit variant="footer" />
      </div>
    </div>
  );
}
